import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Item from "./Item";

const SortableItem = ({ SetVideoId, bucketUrl, setVideoPlayer, setVideoLink, item, setCaptions, onEdit, index, onDelete, imageThumbnailUrl, onPressEdit, onPressDelete, captions, HandleSaveCaption, domId }) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  return (
    <Item
      id={domId}
      ref={setNodeRef}
      style={style}
      withOpacity={isDragging}
      onEdit={onEdit}
      index={index}
      bucketUrl={bucketUrl}
      setCaptions={setCaptions}
      SetVideoId={SetVideoId}
      setVideoPlayer={setVideoPlayer}
      setVideoLink={setVideoLink}
      captions={captions}
      HandleSaveCaption={HandleSaveCaption}
      onDelete={onDelete}
      item={item}
      isDragging={isDragging}
      onPressDelete={onPressDelete}
      onPressEdit={onPressEdit}
      imageThumbnailUrl={imageThumbnailUrl}
      // onEdit={() => onEdit?.(item)}
      // onDelete={() => onDelete?.(item)}
      dragHandleProps={{ ...attributes, ...listeners }} // Pass this to handle only
    />
  );
};

export default SortableItem;
